import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import SupervisorLogin from "../pages/SupervisorLogin";
import Home from "../pages/Home";
import Stock from "../pages/Stock";
import Sales from "../pages/Sales";
import SalesConfirm from "../pages/Sales/Confirm";
import SalesSubmitSuccess from "../pages/Sales/SubmitSuccess";
import Profile from "../pages/Profile";
import Activity from "../pages/Activity";
import RoleGate from "../components/RoleGate";
import SupervisorLayout from "../components/SupervisorLayout";

const Placeholder: React.FC<{ title: string; description?: string }> = ({ title, description }) => {
  return (
    <div className="p-6">
      <div className="text-lg font-medium">{title}</div>
      {description ? <div className="mt-2 text-slate-600">{description}</div> : null}
    </div>
  );
};

function Router() {
  return useRoutes([
    { path: "/login", element: <SupervisorLogin /> },
    { path: "/", element: <Navigate to="/app" replace /> },
    {
      path: "/app",
      element: (
        <ProtectedRoute>
          <RoleGate allow={["APP"]}>
            <SupervisorLayout />
          </RoleGate>
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <Home />,
        },
        { path: "stock", element: <Stock /> },
        { path: "sales", element: <Sales /> },
        { path: "sales/confirm", element: <SalesConfirm /> },
        { path: "sales/success", element: <SalesSubmitSuccess /> },
        { path: "activity", element: <Activity /> },
        { path: "profile", element: <Profile /> },
        { path: "hunt-conquer", element: <Placeholder title="Hunt & Conquer" /> },
        { path: "tribe-ahead", element: <Placeholder title="Tribe Ahead" /> },
      ],
    },
    { path: "*", element: <Navigate to="/app" replace /> },
  ]);
}

export default Router;

